import {
  Component, OnInit, OnDestroy, OnChanges, AfterViewInit,
  Input, trigger, state, transition, style, animate
} from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../../../environments/environment';

// Interfaces
import { IComponent } from '../../interfaces';

// Enums
import { MessageTypeEnum } from '../../../share/enums';
// Services
import * as srv from '../../../share/services';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
  animations: [
    trigger('visibilityChanged', [
      state('shown', style({ opacity: 1, height: '42px' })),
      state('hidden', style({ opacity: 0, height: '0px' })),
      transition('shown=>hidden', animate('2s'))
    ])
  ],
})
export class MessageComponent implements IComponent, AfterViewInit, OnInit, OnDestroy, OnChanges {
  // Implement IComponent
  name = 'MessageComponent';
  subscriptions: Subscription[] = [];

  // implements local variables
  // *
  @Input() Position: string;
  @Input() Class: string;
  classInit: string;
  haveMessage = 'hidden';
  message: string;
  isError: boolean;
  type: MessageTypeEnum;
  private _timeOut: any;
  constructor(
    private _logSrv: srv.LogService,
    private _msgSrv: srv.MessageService
  ) { }

  ngOnInit() {
  }

  ngOnChanges() {
    this._logSrv.Debug(this.name, ['ngOnChanges', this.Position, this.Class]);
    this.classInit = this.Class || '';
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => {
      s.unsubscribe();
    });
    delete this.subscriptions;
  }

  ngAfterViewInit(): void {
    this.subscriptions.push(
      this._msgSrv.showBottomError$.subscribe(
        (message: { message: string, isError: boolean, type: MessageTypeEnum }) => {
          if (this.Position && this.Position === 'bottom') {
            this._showMessage(message);
          }
        }, (err: Error) => {
        })
    );

    this.subscriptions.push(
      this._msgSrv.showTopError$.subscribe(
        (message: { message: string, isError: boolean, type: MessageTypeEnum }) => {
          if (this.Position && this.Position === 'top') {
            this._showMessage(message);
          }
        }, (err: Error) => {
        })
    );

    this.subscriptions.push(
      this._msgSrv.showLocalMessage$.subscribe(m => {
        this._logSrv.Debug(this.name,
          [m.message, this.Position, (this.Position === m.name)]);
        if (this.Position && this.Position === m.name) {
          this._showMessage(m.message);
        }
      }, (err: Error) => {
      })
    );

    this.subscriptions.push(
      this._msgSrv.clearError$.subscribe(
        () => {
          if (this._timeOut) {
            clearTimeout(this._timeOut);
          }
          this.haveMessage = 'hidden';
          this.message = '';
        }, (err: Error) => {
        })
    );

  }

	setMessageLocation(){
		let msgtop = $('app-topbanner nav').height() - $(window).scrollTop();
		msgtop = (msgtop > 0 ? msgtop : 0);

		$('#error.top').css('top',msgtop);
	}

  private _showMessage(message: { message: string, isError: boolean, type: MessageTypeEnum }) {
    if (this._timeOut) {
      clearTimeout(this._timeOut);
	}
	// NH - this can be used later to set the message just below the header OR the top of the screen if
	// scrolling has happened.
	//this.setMessageLocation();
    this.Class = this.classInit + ' ' + String(MessageTypeEnum[message.type]);
    this.haveMessage = 'shown';
    this.message = message.message;
	this.isError = message.isError;
    this._logSrv.Debug(this.name,
      [
        this.isError ? 'Error' : 'Message',
        { message: message, Position: this.Position }
      ]);
    this._timeOut =
      setTimeout(() => {
        this.haveMessage = 'hidden';
      }, 5000);
  }

}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/components/message/message.component.ts